'use client'
import React, { useEffect } from 'react';
import { Autocomplete, Box, TextField, Card, CardContent, CardHeader } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import BallotIcon from '@mui/icons-material/Ballot';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { states, usState } from "../../Models/states";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { GCUsageErrors, GCUsageModel } from '@/app/Models/GCUsageModel';
import { CardSiteDataModel } from "@/app/Models/CardSiteDataModel";
import { CashOutStateModel } from "@/app/Models/CashOutStateModel";
import Processor from "../Enums/Processor";
import dayjs from 'dayjs';


interface Props {
    data: GCUsageModel,
    setData: (model: GCUsageModel) => void;
    cardSiteData: CardSiteDataModel | null;
    cashOutState: CashOutStateModel | null;
    errors: GCUsageErrors;
}

const GCUsageCard: React.FC<Props> = (props) =>{
    
    const processorCode: string = props.cardSiteData?.processorCode ?? "";
    const redemptionRequired: boolean = props.cashOutState?.redemptionRequired ?? true;

    useEffect(() => {
        const nextUsageRequired = processorCode === Processor.Manual && redemptionRequired;
        if (props.data.usageRequired !== nextUsageRequired) {
            props.setData({ ...props.data, usageRequired: nextUsageRequired });
        }
    }, [processorCode, redemptionRequired]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Card sx={{ minWidth: 275}} variant="outlined">
                <CardHeader title='Gift Usage Information' 
                    avatar={
                        <BallotIcon />
                    }/>
                <CardContent>
                    <Box sx={{ display: "flex", alignItems: "flex-end", flexWrap: "wrap" }} >
                        <DatePicker
                            views={['year']}
                            maxDate={dayjs()}
                            value={props.data.cardLastUsedDate}
                            onChange={(newValue) => {
                                props.setData({ ...props.data, cardLastUsedDate: newValue ?? null });
                            }}
                            onAccept={(date) => {
                                if (!date) return;

                                const formatted = date.startOf('year');
                                props.setData({...props.data, cardLastUsedDate: formatted})
                            }}
                            label="Last Used Date"
                            slotProps={{
                                textField: {
                                    variant: "standard",
                                    helperText: " ",
                                    sx: { minWidth: 220 },
                                    autoComplete: 'off',
                                    inputProps: { inputMode: 'numeric' },
                                },
                            }}
                        />
                        <Autocomplete
                            disablePortal
                            id="gc-state-select"
                            options={states}
                            value={props.data.stateLastUsed}
                            onChange={(e: any, newValue: usState | null) => {props.setData({...props.data, stateLastUsed: newValue})}}
                            sx={{ width: 300 }}
                            renderInput={
                                (params) => <TextField 
                                            {...params} 
                                            label="State of Last Use"
                                            helperText="The state in which the last transaction on the card was completed." />
                                } 
                        />
                    </Box>
                </CardContent>
            </Card>
        </LocalizationProvider>
    );
};

export default GCUsageCard